module.exports = __webpack_public_path__ + "05_glasses_red.1cebb837.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/05_glasses_red.png
// module id = ztbL
// module chunks = 0